import { FC } from 'react';
import { cn } from '@/shared/lib';
import { useRTL } from '@/shared/hooks';
import { useTranslation } from 'react-i18next';
import { DeliveryOptionEnum } from '@/entities';
import { ServiceTypeEnum } from '@/app/store/api/restApi';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/shared/shadcn';
import { useAppDispatch, useAppSelector, setDeliveryType, setDeliveryOption } from '@/app/store';
import { CourierDelivery } from './CourierDelivery';
import { OrderPointDelivery } from './OrderPointDelivery';

interface DeliveryAddressContentProps {
  isOrderAnotherPerson: boolean;
  onClose: VoidFunction;
  isModal?: boolean;
}

export const DeliveryAddressContent: FC<DeliveryAddressContentProps> = ({ isOrderAnotherPerson, onClose, isModal }) => {
  const isRTL = useRTL();
  const dispatch = useAppDispatch();
  const { t: tCatalog } = useTranslation('catalog');
  const { deliveryDisabled, orderPointDisabled } = useAppSelector((state) => state.application);
  const deliveryOption = useAppSelector((state) => state.order.deliveryOption);

  const hasTabs = !deliveryDisabled && !orderPointDisabled;
  const noTopMargin = !hasTabs && Boolean(isModal);

  return (
    <div
      className={cn('flex flex-col justify-between h-full w-full overflow-auto', isModal ? 'p-6' : 'pb-footer px-4')}
    >
      <Tabs
        dir={isRTL ? 'rtl' : 'ltr'}
        value={deliveryOption}
        onValueChange={(v) => {
          dispatch(setDeliveryOption(v as DeliveryOptionEnum));
          if (v === DeliveryOptionEnum.Courier) dispatch(setDeliveryType(ServiceTypeEnum.Delivery));
          else dispatch(setDeliveryType(ServiceTypeEnum.OrderPoint));
        }}
        className={cn('gap-2 mt-3 h-full', isModal && 'mt-0')}
      >
        {hasTabs && (
          <TabsList>
            <TabsTrigger value={DeliveryOptionEnum.Courier}>{tCatalog('delivery.courier')}</TabsTrigger>
            <TabsTrigger value={DeliveryOptionEnum.OrderPoint}>{tCatalog('delivery.orderPoint')}</TabsTrigger>
          </TabsList>
        )}

        <TabsContent value={DeliveryOptionEnum.Courier} className='mt-0 h-full'>
          <CourierDelivery isOrderAnotherPerson={isOrderAnotherPerson} onClose={onClose} noTopMargin={noTopMargin} />
        </TabsContent>

        <TabsContent value={DeliveryOptionEnum.OrderPoint} className='mt-0 h-full'>
          <OrderPointDelivery isOrderAnotherPerson={isOrderAnotherPerson} onClose={onClose} noTopMargin={noTopMargin} />
        </TabsContent>
      </Tabs>
    </div>
  );
};
